const gallerySi = {
    "file_upload_successful": "Nalaganje datoteke je bilo uspešno",
    "file_upload_error": "Napaka pri nalaganju datoteke",
    "attach_files": "Priloži datoteke",
    "files_selected": "Izbrane datoteke",
    "upload": "Naloži",
    "uploading": "Nalaganje",
    "maximum_file_size": "Največja dovoljena velikost nalaganja je 10 MB.",
    "download": "Prenesi",
    "open_in_new_tab": "Odpri v novem zavihku",
    "delete_file": "Izbriši datoteko",
    "confirm_delete": "Ali ste prepričani, da želite izbrisati to datoteko?",
    "image_in_use": "Izbrana slika se uporablja v naslednjih aktivnih elementih menija:",
    "image_in_use_tip": "Če želite izbrisati to datoteko, jo odstranite iz vseh aktivnih oglasov.",
    "file_deleted_successfully": "Datoteka je bila uspešno izbrisana",
    "error_deleting_file": "Napaka pri brisanju datoteke",
    "confirm_selection": "Potrdi izbiro",
    "file_deletion_forbidden": "Brisanje datotek prepovedano"
};

export default gallerySi;
